export default __webpack_public_path__ + "static/media/rahimIqbalAbout.29849b51.png";